import React, { FC, useEffect, useState } from 'react';
import { SectionWrapper } from '../SectionWraper';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { FormInput } from '../merchants/FormInput';
import { GetUserInformation } from './ProfileSettingsLayout';
import {
	convertCustomerSupportToInitial,
	CUSTOMER_SUPPORT_FORM_FIELDS,
	customerInitialValues,
	getFormattedCustomerFormFields
} from '../../constants/profile-settings/bussiness-settings-customer-support-form';
import {
	CUSTOMER_SUPPORT_INPUTS
} from '../../constants/profile-settings/bussiness-settings-customer-support-details';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { setCustomerSupportData } from '../../store/merchnts/actions/userSettings';
import { fetchMerchantData } from '../../store/merchnts/actions/merchant';

export const BusinessSettingsCustomerSupportDetails: FC = () => {

	const [isEditMode, setIsEditMode] = useState<boolean>(false);
	const { t } = useTranslation();
	const user = GetUserInformation();
	const id = user['custom:mid'];
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { merchantState: { merchantData, isMerchantDataLoading }, dispatch } = useMerchants();

	const formik = useFormik({
		initialValues: customerInitialValues,
		onSubmit: () => void 0
	});

	useEffect(() => {
		const data = convertCustomerSupportToInitial(merchantData);
		formik.setValues(data);
	}, [merchantData]);

	const handleEditClick = async (): Promise<void> => {
		formik.handleSubmit();
		if (formik.isValid && Object.keys(formik.touched).length > 0) {
			setIsLoading(true);
			const data = getFormattedCustomerFormFields(formik.values);
			await setCustomerSupportData(id, data);
			await fetchMerchantData(dispatch, id);
			setIsEditMode(!isEditMode);
			setIsLoading(false);
		}
	};
	const link = formik.getFieldProps(CUSTOMER_SUPPORT_FORM_FIELDS.LINK).value;
	const INPUTS = CUSTOMER_SUPPORT_INPUTS({ t, link });

	return (
		<SectionWrapper
			title="Customer support"
			sectionAdditionalClass="mb-5 min-height-200"
			isEditMode={isEditMode}
			setIsEditMode={setIsEditMode}
			onEditClick={handleEditClick}
			loading={isLoading}
			pageLoading={isMerchantDataLoading}
			isCardBody
		>
			<div className="row">
				{
					INPUTS.map(item => {
						return (
							<FormInput
								{...item}
								key={item.key}
								formik={formik}
								isEditMode={isEditMode}
							/>
						);
					})
				}
			</div>
		</SectionWrapper>
	);
};
